import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Container,
  FlexContainer,
  HeartsIconContainer,
  IntercourseReminderContainer,
  SimpleFlex
} from './IntercourseReminder.styled';
import IntercourseHeartsIcon from 'assets/icons/intercourse-hearts.svg?react';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Heading } from 'components/v2/Typography/Heading';
import { Text } from 'components/v2/Typography/Text';
import { formatDate } from 'utilities/formatDate';
import { pageUrl } from 'utilities/pageUrl';

export const IntercourseReminder = ({ date }: { date?: string }) => {
  const navigate = useNavigate();

  return (
    <Container>
      <HeartsIconContainer>
        <IntercourseHeartsIcon />
      </HeartsIconContainer>
      <IntercourseReminderContainer>
        <FlexContainer>
          <SimpleFlex>
            {date && (
              <Text tag="p" size="sm">
                {formatDate(date, 'dddd, MMM Do')}
              </Text>
            )}
            <Heading tag="h2" noMargin>
              Intercourse reminder!
            </Heading>
            <Text tag="p">
              Today&apos;s the day! Make sure to have sex with your partner today.
            </Text>
          </SimpleFlex>
          <Button
            category="secondary"
            label="My Journey"
            onClick={() => navigate(pageUrl.myJourney())}
            uppercase
          />
        </FlexContainer>
      </IntercourseReminderContainer>
    </Container>
  );
};
